import { Button } from "@/components/ui/button";
import { MapPin, Stethoscope, ArrowRight, CalendarDays } from "lucide-react";

const mapUrl = (loc) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(loc)}`;

export default function DoctorCard({ d, index, onBook }) {
  return (
    <div data-testid="landing-doctor-card" style={{ animationDelay: `${index * 80}ms` }}
      className="bg-white rounded-3xl border border-slate-200 overflow-hidden flex flex-col animate-fade-up hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
      <div className="relative h-56">
        <img src={d.avatar} alt={d.name} crossOrigin="anonymous" className="h-full w-full object-cover" />
        <span className="absolute top-4 left-4 bg-teal-600 text-white text-xs font-semibold px-3 py-1.5 rounded-full flex items-center gap-1.5">
          <Stethoscope className="h-3.5 w-3.5" /> {d.specialty}
        </span>
      </div>
      <div className="p-6 flex flex-col flex-1">
        <h3 className="font-head text-xl font-bold text-slate-900">{d.name}</h3>
        <p className="text-teal-700 text-sm font-medium">{d.specialty}</p>
        <p className="mt-3 text-sm text-slate-600 leading-relaxed flex-1">{d.about}</p>

        {(d.available_days || d.available_hours) && (
          <div className="mt-4 flex items-start gap-2 text-sm text-slate-600 bg-teal-50/60 rounded-lg px-3 py-2">
            <CalendarDays className="h-4 w-4 text-teal-600 mt-0.5 shrink-0" />
            <span data-testid="doctor-availability"><span className="font-medium">{d.available_days}</span>{d.available_hours ? ` • ${d.available_hours}` : ""}</span>
          </div>
        )}

        {d.location && (
          <div className="mt-4 rounded-xl overflow-hidden border border-slate-200">
            <iframe title={`map-${d.id}`} data-testid="doctor-map-embed" loading="lazy" referrerPolicy="no-referrer-when-downgrade"
              src={`https://maps.google.com/maps?q=${encodeURIComponent(d.location)}&z=14&output=embed`} className="w-full h-36" />
          </div>
        )}

        <a href={mapUrl(d.location)} target="_blank" rel="noopener noreferrer" data-testid="doctor-map-link"
          className="mt-3 flex items-start gap-2 text-sm text-slate-500 hover:text-teal-700 border-t border-slate-100 pt-4 group">
          <MapPin className="h-4 w-4 text-teal-600 mt-0.5 shrink-0 group-hover:scale-110 transition-transform" />
          <span className="underline-offset-2 group-hover:underline">{d.location}</span>
        </a>

        <Button data-testid="book-now-button" onClick={() => onBook(d)} className="mt-5 w-full bg-teal-600 hover:bg-teal-700 text-white">
          Book Now <ArrowRight className="h-4 w-4 ml-2" />
        </Button>
      </div>
    </div>
  );
}
